import { useEffect, useRef, useState } from "react"
import { Form } from "../forms/Form"

export function Tabs({ tabs = {}, ...props }) {
    const [tab, setTab] = useState(Object.keys(tabs)[0])

    useEffect(() => {
        if (!tabs[tab]) setTab(Object.keys(tabs)[0])
    }, [tabs])

    return <div {...props} className={`flex flex-col gap-8 ${props.className || ''}`}>
        <div className="flex overflow-auto">
            {Object.keys(tabs).map(name =>
                <button key={name} onClick={() => setTab(name)} className={`px-5 py-2 bg-gray-200 first:border-l border-r border-y  border-gray-300 first:rounded-l-lg last:rounded-r-lg cursor-pointer whitespace-nowrap ${name === tab ? 'bg-white' : 'hover:bg-white'}`}>{name}</button>
            )}
        </div>
        {tabs[tab]}
    </div>
}

export function TabbedCard({ children, tabs = [], tab, setTab, ...props }) {
    return <div {...props}>
        {tabs.length > 0 && <div className="flex gap-1 mx-3 translate-y-px overflow-auto">
            {tabs.map(name =>
                <button key={name} onClick={() => setTab(name)} className={`px-5 py-2 bg-gray-200 border border-gray-300 rounded-t-lg cursor-pointer whitespace-nowrap ${name === tab ? 'bg-white border-b-white' : 'hover:bg-white hover:border-b-white'}`}>{name}</button>
            )}
        </div>}
        <div className="bg-white border border-gray-300 rounded-xl">
            {children}
        </div>
    </div>
}

export function TabbedForm({ children, onSubmit, tabs = [], tab, setTab, ...props }) {
    const [validating, setValidating] = useState(false)
    const [originalTab, setOriginalTab] = useState()
    const formContainer = useRef()

    const submit = async () => {
        setValidating(true)
        setOriginalTab(tab)
        setTab(tabs[0])
    }
    useEffect(() => {
        if (validating) {
            const valid = formContainer.current.querySelector('form').checkValidity()
            if (valid && tab === tabs[tabs.length - 1]) {
                setValidating(false)
                setTab(originalTab)
                onSubmit()
            } else if (valid) {
                setTab(tabs[tabs.indexOf(tab) + 1])
            } else {
                setValidating(false)
                setTimeout(() => {
                    formContainer.current.querySelector('form').requestSubmit()
                })
            }
        }
    }, [tab, validating])
    useEffect(() => {
        if (!tabs[tab]) setTab(tabs[0])
    }, [tabs])

    return <TabbedCard {...props} tabs={tabs} tab={tab} setTab={setTab}>
        <div ref={formContainer}>
            <Form onSubmit={submit} className="p-5">
                {children}
            </Form>
        </div>
    </TabbedCard>
}